var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('ul',{staticClass:"crumbs"},_vm._l((_vm.list.filter(function (ref) {
	var title = ref.title;

	return title !== _vm.$t('productCatalog');
})),function(item){return _c('li',{attrs:{"itemprop":"itemListElement"}},[_c('router-link',{attrs:{"to":_vm.$linkwrap({ name: item.name, params: { categorySlug: item.slug } })}},[_vm._v(" "+_vm._s(item.title)+" ")])],1)}),0),_c('script',{attrs:{"type":"application/ld+json"},domProps:{"innerHTML":_vm._s(_vm.generateProp())}})])}
var staticRenderFns = []

export { render, staticRenderFns }